import React, { useState } from 'react';
 import { Box, TextField, Button, Paper, Typography } from '@mui/material';
 
 const fieldLabels = {
   name: 'Name',
   phone: 'Mobile',
   email: 'Email',
   organization: 'Organization',
   department: 'Department',
   city: 'City',
   interest: 'What interests you most about our solutions?',
   comments: 'Comments'
 };
 
 const ContactForm = ({ fields, onSubmit, message }) => {
   const [formData, setFormData] = useState(
     fields.reduce((acc, field) => ({ ...acc, [field]: '' }), {})
   );
 
   const handleSubmit = (e) => {
     e.preventDefault();
     onSubmit(formData);
   };
 
   const handleChange = (field) => (e) => {
     setFormData(prev => ({
       ...prev,
       [field]: e.target.value
     }));
   };
 
   return (
     <Paper 
       component="form" 
       onSubmit={handleSubmit}
       sx={{
         p: 2,
         backgroundColor: '#fff',
         borderRadius: 2,
       }}
     >
       {message && (
         <Typography 
           variant="body1" 
           sx={{ 
             mb: 3,
             color: '#666',
             textAlign: 'center',
             fontSize: '1rem',
             fontWeight: 500
           }}
         >
           {message}
         </Typography>
       )}
       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
         {fields.map((field) => (
           <TextField
             key={field}
             label={fieldLabels[field]}
             value={formData[field]}
             onChange={handleChange(field)}
             fullWidth
             variant="outlined"
             multiline={field === 'interest' || field === 'comments'}
             rows={field === 'interest' || field === 'comments' ? 4 : 1}
             sx={{
               '& .MuiOutlinedInput-root': {
                 backgroundColor: '#f5f5f5',
               }
             }}
           />
         ))}
         <Button 
           type="submit" 
           variant="contained" 
           color="primary"
           sx={{
             mt: 1,
             py: 1.5,
             textTransform: 'none',
             fontSize: '1rem',
             backgroundColor: '#9D1680',
             '&:hover': {
               backgroundColor: '#9D1680',
             },
           }}
         >
           Submit
         </Button>
       </Box>
     </Paper>
   );
 };
 
 export default ContactForm; 